/**
 * Query keys of the operator area (F-69). Every key starts with `platform`, so a change invalidates
 * the whole area at once; further pages of the area (F-70) add their keys here.
 */
export const platformQueryKeys = {
  all: ["platform"] as const,
  account: ["platform", "account"] as const,
  tenants: ["platform", "tenants"] as const,
  tenant: (tenantId: string) => ["platform", "tenants", tenantId] as const,
  lifecycle: (tenantId: string) => ["platform", "tenants", tenantId, "lifecycle"] as const,
  usage: (tenantId: string) => ["platform", "tenants", tenantId, "usage"] as const,
  contacts: (tenantId: string) => ["platform", "tenants", tenantId, "contacts"] as const,
  legalAcceptances: (tenantId: string) =>
    ["platform", "tenants", tenantId, "legal-acceptances"] as const,
  singleSignOn: (tenantId: string) => ["platform", "tenants", tenantId, "single-sign-on"] as const,
  emergencyAccesses: (tenantId: string) =>
    ["platform", "tenants", tenantId, "emergency-accesses"] as const,
  plans: ["platform", "plans"] as const,
  databases: ["platform", "databases"] as const,
  databaseOptions: ["platform", "database-options"] as const,
  signups: ["platform", "signups"] as const,
  onboarding: (tenantId: string) => ["platform", "onboardings", tenantId] as const,
  payment: (tenantId: string) => ["platform", "tenants", tenantId, "payment"] as const,
  invoices: (tenantId: string) => ["platform", "tenants", tenantId, "invoices"] as const,
  offboarding: (tenantId: string) => ["platform", "tenants", tenantId, "offboarding"] as const,
  legalDocuments: ["platform", "legal-documents"] as const,
  subprocessors: ["platform", "subprocessors"] as const,
  subprocessorNotices: (announcementId: string) =>
    ["platform", "subprocessor-announcements", announcementId, "notices"] as const,
  // Pages of the platform functions (F-79).
  auditLog: (filters: object) => ["platform", "audit-log", filters] as const,
  planVersions: ["platform", "plan-versions"] as const,
  planPrices: ["platform", "plan-prices"] as const,
  trial: (tenantId: string) => ["platform", "tenants", tenantId, "trial"] as const,
  systemStatus: ["platform", "system-status"] as const,
  staffAccounts: ["platform", "accounts"] as const,
};
